import React from 'react';
import LoadingScreen from "components/complex/loadingScreen/LoadingScreen";


const ImporterForm = (
    {
        downloadingInProgress
    }) => {


    return (
        <>
            {downloadingInProgress ? <LoadingScreen/> : ''}
        </>
    )
};


export default ImporterForm

